import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const snyk = defineConnector({
  identifier: "snyk",
  name: "Snyk",
  tagLine: "Developer security scanning",
  logo,
  protocol: "http",
  tags: ["security", "engineering"],
  defaultUrlPattern: () => "https://api\\.snyk\\.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "token",
      },
    ]),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Snyk account settings](https://app.snyk.io/account) and copy your API token from the General Settings section.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "Snyk API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.snyk.io/rest/self?version=2024-10-15",
  },
});
